import { helpers } from 'vuelidate/lib/validators';

export const phoneValidator = helpers.regex(
  'phone',
  /^[+]{1,2}[0-9]+ [(][0-9]{3}[)] [0-9]{3}-[0-9]{2}-[0-9]{2}$/
);
